import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import Router from './Router.tsx';
import { ErrorProvider } from '@/context/error';
import '@/styles/styles.scss';
import './i18n/i18n';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorProvider>
      <Router />
    </ErrorProvider>
  </StrictMode>
);
